<template>
    <div class="tw-relative">
        <!-- Displayed image (or icon) -->
        <portrait
        :size="size"
        :location="picture"
        :circle="circle"
        :icon="icon"></portrait>
        <!--  -->
        
        <!-- Edit icon -->
        <div 
        class="tw-absolute tw-top-0 tw-inset-x-0 tw-flex tw-items-center tw-justify-center tw-w-full tw-h-full tw-text-white tw-text-xl tw-cursor-pointer tw-opacity-0 hover:tw-opacity-100 tw-bg-black tw-bg-opacity-50" 
        :class="{'tw-rounded-full':circle}"
        v-if="editable"
        @click="openPictureModal"
        :style="{fontSize : svgSize}">
            <i class="fa fa-pencil-square-o" v-if="hasPicture"></i>
            <i class="fa fa-cloud-upload" v-else></i>
        </div>
        <!--  -->

        <!-- Edit modal -->
        <modal-content name="edit-picture" ref="editPictureModal">
            <template #body>
                <div>
                    <base-form
                    :ajax="true"
                    :action="editAction"
                    v-slot="{ loading, submit, errors }"
                    @success="event => replacePicture(event)">
                        <!-- Edit options -->
                        <div v-show="pictureAction == null">
                            <div class="tw-flex tw-space-x-2">
                                <div class="btn btn-default tw-flex-1 tw-text-center tw-py-10 tw-text-lg" @click="displayEditCropForm">
                                    <i class="fa fa-crop"></i> Edit Crop
                                </div>
                                <div class="btn btn-default tw-flex-1 tw-text-center tw-py-10 tw-text-lg" @click="displayReplacePictureForm">
                                    <i class="fa fa-refresh"></i> Replace Picture
                                </div>
                            </div>
                        </div>
                        <!--  -->
                        <!-- Crop existing image -->
                        <div v-if="hasPicture && pictureAction == 'crop'">
                            <div class="btn btn-sm btn-default tw-mb-4" @click="back"><i class="fa fa-angle-left"></i> Back</div>
                            <form-control name="picture" :additional-errors="['picture\..*']">
                                <cropper-field
                                ref="cropper"
                                name="pictureCrop"
                                :use-modal="false"
                                :cropControls="false"
                                :stencil="stencil"
                                @ready="event => submittable = true"
                                :crop-props="{
                                    src: originalPicture
                                }"></cropper-field>
                            </form-control>
                        </div>
                        <!--  -->
                        <!-- Upload/replace image -->
                        <div v-if="pictureAction == 'replace'">
                            <div v-if="hasPicture" class="btn btn-sm btn-default tw-mb-4" @click="back"><i class="fa fa-angle-left"></i> Back</div>
                            <form-control name="picture" :additional-errors="['picture\..*']">
                                <file-dropzone
                                name="picture"
                                :crop="true"
                                :crop-button="false"
                                :circle="circle"
                                :crop-field-props="{
                                    class:'tw-mt-4',
                                    useModal: false,
                                    cropControls: false
                                }"
                                @file="submittable = true"
                                @clear="event => { submittable = false; errors.clearAll(); }"></file-dropzone>
                            </form-control>
                        </div>
                        <!--  -->
                        <portal to="picture-submit">
                            <submit-button @click.native="submit()" class="btn-success" :loading="loading" :disabled="!submittable">Submit</submit-button>
                        </portal>
                    </base-form>

                    <base-form
                    v-if="hasPicture"
                    :ajax="true"
                    :action="deleteAction"
                    v-slot="{ loading, submit }"
                    @success="event => replacePicture(event)">
                        <portal to="picture-remove">
                            <submit-button @click.native="submit()" class="btn-danger" :loading="loading">Remove</submit-button>
                        </portal>
                    </base-form>
                </div>
            </template>

            <template #footer>
                <div class="tw-flex tw-justify-between">
                    <portal-target name="picture-remove"></portal-target>
                    
                    <div class="tw-flex tw-space-x-2 tw-justify-end">
                        <button type="button" class="btn btn-secondary" @click="cancel">Cancel</button>
                        <portal-target name="picture-submit"></portal-target>
                    </div>
                </div>
            </template>
        </modal-content>
        <!--  -->
    </div>
</template>

<script>
export default {
    name: "PhotoUploader",

    props: {
        size: {
            type: String,
            default: "40px"
        },
        location: {
            type: String,
            default: ""
        },
        circle: {
            type: Boolean,
            default: true
        },
        icon: {
            type: String,
            default: 'fa fa-user'
        },
        original: String,
        editable: {
            type: Boolean,
            default: false
        },
        editAction: String,
        deleteAction: String
    },

    data() {
        return {
            picture: this.location,
            originalPicture: this.original,
            pictureAction: null,
            submittable: false
        }
    },

    computed: {
        hasPicture() {
            return this.picture ? true : false;
        },
        svgSize() {
            return Math.round(this.size.replace("px", '') / 3.33) + 'px';
        },
        stencil() {
            return this.circle ? 'circle-stencil' : 'rectangle-stencil';
        }
    },

    mounted() {
        this.resetPictureModal();
    },

    methods: {
        replacePicture(event) {
            this.picture = event.crop;
            this.originalPicture = event.original;

            this.$refs.editPictureModal.close();

            this.resetPictureModal();
        },

        resetPictureModal() {
            this.pictureAction = this.hasPicture ? null : 'replace';
            this.submittable = false;
        },

        openPictureModal() {
            this.$refs.editPictureModal.open();
        },

        displayEditCropForm() {
            this.pictureAction = 'crop';
        },

        displayReplacePictureForm() {
            this.pictureAction = 'replace';
        },

        back() {
            this.pictureAction = null;
            this.submittable = false;
        },

        cancel() {
            this.resetPictureModal();
            this.$refs.editPictureModal.close();
        }

    }
}
</script>

<style>

</style>